import { TableContainer, Table, TableHead, TableRow, TableCell, TableFooter, Typography } from '@mui/material';
import { calculateIva, calculateTotalWithIva, totalCertification, totalCompleteRent, diffDates } from '../../helpers/productsPrice';
import './style.css'

export const CertificationTotalTable = ({ formValues }) => {
    console.log(formValues)
    const { rents, product, firstDate, lastDate, rentsDays } = formValues;
    const dayRents = firstDate ? diffDates(firstDate, lastDate) : rentsDays;
    const rentsToObj = JSON.parse(rents);
    const totalRentImport = totalCompleteRent(rentsToObj, dayRents);
    const products = JSON.parse(product);

    return (
        <TableContainer component='div'>
            <Table sx={{ minWidth: 650 }} size='small' aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Importe sin IVA: <b>{totalCertification(products, totalRentImport).toFixed(2)}€</b></TableCell>
                        <TableCell align="center" >IVA {formValues.iva}: <b>{calculateIva(totalCertification(products, totalRentImport), formValues.iva)}</b></TableCell>
                        <TableCell align="center" >Total con IVA: <b>{calculateTotalWithIva(totalCertification(products, totalRentImport), formValues.iva)}</b></TableCell>
                    </TableRow>

                </TableHead>
            </Table>
            <TableFooter >
                <Typography variant='caption' style={{marginLeft:'25px'}}><b>Nº de Cta Cte:</b> BANKINTER  ES22 01280012830100075211 CAIXABANK  ES58 21003630561301176504</Typography>
            </TableFooter>
        </TableContainer>
    )
}